/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Note } from '../models/Note';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotesService {
    /**
     * Get all notes
     * @returns Note successful
     * @throws ApiError
     */
    public static getAllNotes(): CancelablePromise<Array<Note>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notes.json',
        });
    }
    /**
     * Create note
     * @param requestBody
     * @returns Note successful
     * @throws ApiError
     */
    public static createNote(
        requestBody?: {
            content_id: string;
            text: string;
            quiz_id?: number | null;
            section_id?: string | null;
        },
    ): CancelablePromise<Note> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notes.json',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete note
     * @param id
     * @returns Note successful
     * @throws ApiError
     */
    public static deleteNote(
        id: string,
    ): CancelablePromise<Array<Note>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/notes/{id}.json',
            path: {
                'id': id,
            },
        });
    }
}
